/* eslint-disable react-hooks/exhaustive-deps */
import { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import {
  ERROR_MSG_TYPE,
  SUBFAILED,
  SUCCESS_MESSAGE,
  SUCCESS_MSG_TYPE,
} from "../../constants/messages";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Layout,
  Table,
  Input,
  Form,
  Spin,
  Select,
} from "antd";
import {
  ALL_VENDOR,
  DELETE_VENDOR,
  STAFF,
  UPDATE_VENDOR_DOCUMENT_STATUS,
} from "../../constants/api";
import {
  ACTIVE_INACTIVE_OPTION,
  getHotelType,
  getLoginId,
  HOTEL_ID_SERIES,
  isBDE,
  isSuperAdmin,
} from "../../constants/constent";
import VendorStatusForm from "./blocs/VendorStatusForm";
import VendorActions from "./blocs/VendorActions";
import VendorDocumentModal from "./blocs/VendorDocumentModal";

function VendorTable() {
  const { Content } = Layout;
  const { Option } = Select;

  // Get the search (query params) from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type"); // Extract type from URL

  const [col_form] = Form.useForm();

  const [state, setState] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  const [docModalOpen, setDocModalOpen] = useState(false);
  const [vendorId, setVendorId] = useState(null);

  const [bdes, setBdes] = useState([]);
  const [selectedBDE, setSelectedBDE] = useState(isBDE() ? getLoginId() : null);

  const navigate = useNavigate();

  /* ================= FETCH LIST ================= */

  // ------------------------------------
  // FETCH BDEs
  // ------------------------------------
  useLayoutEffect(() => {
    fetchBDEs();
  }, []);

  const fetchBDEs = () => {
    setLoading(true);
    getAPI(
      STAFF,
      (res) => {
        if (res.status) {
          setBdes(res.data.filter((u) => u.user_type === "bde"));
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch BDEs");
        setLoading(false);
      },
    );
  };

  useLayoutEffect(() => {
    getList();
  }, [selectedBDE]);

  const onSubmit = (payload) => {
    setLoading(true);

    // Create a new payload object by stripping the dynamic field names (e.g., `status_${id}`) and renaming them to just 'status'.
    const newPayload = { ...payload };

    // Loop through the keys of the payload and rename them if they match the pattern
    Object.keys(payload).forEach((key) => {
      if (key.startsWith("status_")) {
        newPayload["status"] = payload[key]; // Use "status" instead of "status_{id}"
        delete newPayload[key]; // Remove the original dynamic field
      }
      if (key.startsWith("is_approved_")) {
        newPayload["is_approved"] = payload[key]; // Use "is_approved" instead of "is_approved_{id}"
        delete newPayload[key]; // Remove the original dynamic field
      }
    });
    postAPI(
      UPDATE_VENDOR_DOCUMENT_STATUS,
      payload,
      (res) => {
        if (res.status) {
          getList();
          displayMessage(SUCCESS_MSG_TYPE, res.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, SUBFAILED);
      },
    );
  };

  const getList = () => {
    setLoading(true);
    getAPI(
      ALL_VENDOR +
        (selectedBDE ? "?bde=" + selectedBDE : "") +
        (type ? "?type=" + type : ""),
      (res) => {
        if (res.status) {
          const rows = res.data.map((row, index) => {
            return {
              key: row.id,
              id: index + 1,
              ...row,
              hotel_id: HOTEL_ID_SERIES + row.hotel_id,
              hotel_type: getHotelType(row.hotel_type),
              plan_name: row.active_plan.plan_name,
              sales_man: row.sales_man.name,
              update_action: (
                <VendorStatusForm
                  vendor={row}
                  form={col_form}
                  onSubmit={onSubmit}
                />
              ),
              action: (
                <VendorActions
                  vendor={row}
                  onDelete={deleteData}
                  onVerify={openDocModal}
                  navigate={navigate}
                  onRefresh={getList}
                />
              ),
            };
          });

          setState(rows);
          setFilteredData(rows);
        } else {
          setState([]);
          setFilteredData([]);
        }
        setLoading(false);
      },
      () => setLoading(false),
    );
  };

  /* ================= DELETE ================= */

  const deleteData = (id) => {
    postAPI(
      DELETE_VENDOR,
      { id },
      (res) => {
        if (res.status) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          getList();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => displayMessage(ERROR_MSG_TYPE, "Delete failed"),
    );
  };

  /* ================= SEARCH ================= */

  const handleSearch = (value) => {
    setSearchText(value);
    setFilteredData(
      state.filter(
        (v) =>
          v.hotel_name.toLowerCase().includes(value.toLowerCase()) ||
          v.hotel_contact_person.toLowerCase().includes(value.toLowerCase()) ||
          v.vendor_name.toLowerCase().includes(value.toLowerCase()) ||
          v.hotel_type.toLowerCase().includes(value.toLowerCase()) ||
          v.sales_man.toLowerCase().includes(value.toLowerCase()) ||
          v.plan_name.toLowerCase().includes(value.toLowerCase()) ||
          v.hotel_id.includes(value) ||
          v.hotel_mobile_no.includes(value) ||
          v.hotel_email_id.includes(value) ||
          v.hotel_whatsapp_no.includes(value),
      ),
    );
  };

  /* ================= DOCUMENT MODAL ================= */

  const openDocModal = (id) => {
    setVendorId(id);
    setDocModalOpen(true);
  };

  /* ================= TABLE ================= */

  const columns = [
    { title: "S. No.", dataIndex: "id" },
    { title: "Hotel ID", dataIndex: "hotel_id" },
    { title: "Hotel Name", dataIndex: "hotel_name" },
    { title: "Type of Hotel", dataIndex: "hotel_type" },
    { title: "Vendor Name", dataIndex: "vendor_name" },
    { title: "Active Plan", dataIndex: "plan_name" },
    { title: "Salesperson", dataIndex: "sales_man" },
    { title: "Verification Status", dataIndex: "update_action" },
    { title: "Actions", dataIndex: "action" },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title={
            ACTIVE_INACTIVE_OPTION.find((item) => item.value === type)?.label
              ? ACTIVE_INACTIVE_OPTION.find((item) => item.value === type)
                  ?.label + " Vendor"
              : "Manage Vendor"
          }
          extra={
            <Space>
              {/* BDE FILTER */}
              {isSuperAdmin() && (
                <Select
                  style={{ width: 200 }}
                  placeholder="Filter by BDE"
                  allowClear
                  onChange={setSelectedBDE}
                  value={selectedBDE}
                >
                  <Option value={null}>All</Option>
                  {bdes.map((bde) => (
                    <Option key={bde.id} value={bde.id}>
                      {bde.name}
                    </Option>
                  ))}
                </Select>
              )}
              {/* SEARCH */}
              <Input
                placeholder="Search by Hotel Name, "
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <Button onClick={() => navigate("/vendor/on-boarding")}>
                On Boarding <PlusOutlined />
              </Button>
              <Button ghost type="primary" loading={loading} onClick={getList}>
                <ReloadOutlined />
              </Button>
            </Space>
          }
        >
          <Spin spinning={loading}>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 800 }}
            />
          </Spin>
        </Card>
      </Content>

      {/* ================= DOCUMENT MODAL ================= */}
      <VendorDocumentModal
        open={docModalOpen}
        vendorId={vendorId}
        onClose={() => setDocModalOpen(false)}
        refreshList={getList}
      />

      <LayoutFooter />
    </Layout>
  );
}

export default VendorTable;
